import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  Spin,
  Table,
  Space,
  Switch,
  Row,
  InputNumber,
  Button,
  Card,
} from "antd";
import { useLocation, useNavigate, Link } from "react-router-dom";
import _ from "lodash";
import PageTitle from "components/PageTitle";
import TableBar from "components/TableBar";
import { parseQueryParams, stringifyQueryParams } from "utils/url";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import {
  getManager,
  updateUser,
  partnerpayoutpayinpermission,
  partnerpayoutpayoutpermission,
  updatePartnerPayinPayout,
} from "requests/user";

const MerchantList = () => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [page, setPage] = useState();
  const [perPage, setPerPage] = useState(
    process.env.REACT_APP_RECORDS_PER_PAGE
  );
  const [totalCount, setTotalCount] = useState(0);
  const [records, setRecords] = useState([]);

  const searchRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [baseUrl, setBaseUrl] = useState("");
  const config = useSelector((state) => state.config);

  const titles = [{ title: "Merchant" }];

  const UpdateStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 || currentStatus === "1" ? 0 : 1;

    try {
      const response = await axios.post(
        "https://billpay.mtmpay.in/Admin/api/admin/user-change-status",
        { id, status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.status === "1") {
        toast.success("Merchant Status updated successfully");
        getRecords();
      } else {
        toast.error(response.data.message || "Failed to update status");
      }
    } catch (error) {
      toast.error("Something went wrong while updating status.");
      console.error(error);
    }
  };


  const columns = [
    // {
    //     title: 'Email',
    //     key: 'email',
    //     dataIndex: 'email'
    // },

    {
      title: "Merchant Detail",
      render: (text, record) => (
        <div>
          <div>
            <span> {record.fullname}</span>

          </div>
          <div>
            <a href={`mailto:${record.email}`}>
              {record.email}
            </a>
          </div>
        </div>
      ),
    },
    {
      title: 'Password',
      key: 'simple_password',
      dataIndex: 'simple_password'
    },
    // {
    //   title: "Partner Detail",
    //   render: (text, record) => (
    //     <div>
    //       <div>
    //         <a href={`mailto:${record.partneremail}`}>{record.partneremail}</a>
    //       </div>
    //       <div>
    //         <span> {record.partnerpassword}</span>
    //       </div>
    //     </div>
    //   ),
    // },

    {
      title: 'Phone',
      key: 'mobile',
      dataIndex: 'mobile',
    },
    {
      title: 'Document',
      dataIndex: 'document',
      key: 'document',
      render: (image, record) => {
        const fullUrl = image ? `${baseUrl}/${image}` : null;
        return fullUrl ? (
          <img src={fullUrl} alt="doc" style={{ maxWidth: '70px', maxHeight: '70px' }} />
        ) : (
          <span style={{ color: '#999' }}>No Image</span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Switch
          checked={status === 1 || status === "1"}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={() => UpdateStatus(record._id || record.id, status)}
        />
      ),
    },
    // {
    //     title: 'Actions',
    //     render: (record) => (
    //         <Link to={`/merchant/${record._id}/partner`}>
    //             <Button>Partner</Button>
    //         </Link>
    //     )
    // },
    // {
    //   title: "Payin",
    //   key: "payin_permission_assign",
    //   dataIndex: "payin_permission_assign",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         <Switch
    //           defaultChecked={
    //             record.partnerpayin_permission_assign == 0 ? false : true
    //           }
    //           checkedChildren={
    //             record.partnerpayin_permission_assign == 1
    //               ? "Active"
    //               : "Inactive"
    //           }
    //           unCheckedChildren={
    //             record.partnerpayin_permission_assign == 0
    //               ? "Inactive"
    //               : "Active"
    //           }
    //           // onChange={(value) => onUpdate(record.userid, { payin_permission_assign: Number(record.partnerpayin_permission_assign) })}
    //           onClick={() =>
    //             payin_change_status(
    //               record.partnerid,
    //               record.partnerpayin_permission_assign
    //             )
    //           }
    //         />
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Payout",
    //   key: "payout_permission_assign",
    //   dataIndex: "payout_permission_assign",
    //   render: (text, record) => {
    //     return (
    //       <Switch
    //         defaultChecked={
    //           record.partnerpayout_permission_assign == 0 ? false : true
    //         }
    //         checkedChildren={
    //           record.partnerpayout_permission_assign == 1
    //             ? "Active"
    //             : "Inactive"
    //         }
    //         unCheckedChildren={
    //           record.partnerpayout_permission_assign == 0
    //             ? "Inactive"
    //             : "Active"
    //         }
    //         // onChange={(value) => onUpdate(record.userid, { payout_permission_assign: Number(record.partnerpayout_permission_assign) })}
    //         onClick={() =>
    //           payout_change_status(
    //             record.partnerid,
    //             record.partnerpayout_permission_assign
    //           )
    //         }
    //       />
    //     );
    //   },
    // },
    // {
    //   title: "Actions",
    //   render: (record) => (
    //     <Link to={`/partner-setting-user?partnerid=${record.partnerid}`}>
    //       <Button className="gradiant_btn">Manage</Button>
    //     </Link>
    //   ),
    // },
  ];
  const handleClick = (id) => {
    window.location.href = `/partner-setting-user?partnerid=${id}`;
  };
  useEffect(() => {
    const query = parseQueryParams(location);
    getRecords(query);
  }, [location]);

  const getRecords = async (query) => {
    try {
      setIsTableLoading(true);
      const response = await getManager(query);
      setBaseUrl(response.baseUrl);
      // console.warn(response.per_page);
      setRecords(response.data);
      setPage(response.page);
      setPerPage(response.per_page);
      setTotalCount(response.total_record);
    } catch (err) {
      console.log(err);
    } finally {
      setIsTableLoading(false);
    }
  };
  const payin_change_status = async (id, data) => {
    if (data == 1) {
      var key = 0;
    } else {
      var key = 1;
    }
    id = {
      userid: id,
      payin_permission_assign: key,
    };
    await partnerpayoutpayinpermission(id);
    getRecords();
  };

  const payout_change_status = async (id, data) => {
    if (data == 1) {
      var key = 0;
    } else {
      var key = 1;
    }
    id = {
      userid: id,
      payout_permission_assign: key,
    };
    await partnerpayoutpayoutpermission(id);
    getRecords();
  };

  const onUpdate = _.debounce(async (id, data) => {
    try {
      setIsTableLoading(true);
      await updateUser(id, data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsTableLoading(false);
    }
  }, 500);

  const onSearch = (keyword) => {
    let query = parseQueryParams(location);
    query = {
      ...query,
      page: 1,
      keyword: keyword,
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  const onRefresh = () => {
    let query = parseQueryParams(location);
    query = {
      page: 1,
      keyword: "",
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });

    if (searchRef.current?.input.value) {
      searchRef.current.handleReset();
    }
  };

  const onChangeTable = (pagination) => {
    console.log(pagination);

    let query = parseQueryParams(location);
    query = {
      ...query,
      page: pagination.current,
      per_page: pagination.pageSize,
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  // const onUpdate1 = _.debounce(async (id, data) => {
  //     try {
  //         // setIsTableLoading(true);
  //         await updatePartner(id, data);
  //     } catch (err) {
  //         console.log(err);
  //     } finally {
  //         // setIsTableLoading(false);
  //     }
  // }, 500);
  const handleChange = _.debounce(async (id) => {
    try {
      setIsTableLoading(true);
      await updatePartnerPayinPayout(id.target.value);
    } catch (err) {
      console.log(err);
    } finally {
      setIsTableLoading(false);
    }
  }, 500);

  return (
    <div>
      <div className="display_flex mb-20">
        <Card className="small_card">
          <PageTitle titles={titles} />
        </Card>
        <Row justify="space-between" align="middle">
          <Card className="small_card">
            <TableBar
              onSearch={onSearch}
              showFilter={false}
              placeholderInput="Search..."
              inputRef={searchRef}
            />
          </Card>
        </Row>
      </div>
      <Spin spinning={isTableLoading}>
        <Table
          style={{ marginTop: "10px" }}
          dataSource={records}
          columns={columns}
          onChange={onChangeTable}
          rowKey={"id"}
          pagination={{
            pageSize: perPage,
            total: totalCount,
            current: page,
          }}
          scroll={{
            x: true,
          }}
        />
      </Spin>
      <ToastContainer />
    </div>
  );
};

export default MerchantList;
